import { HighlightedText } from './highlighted-text'

type AnnouncementTitleProps = {
  title: string
  /** Substring of `title` to render as the accent span; empty string = no accent. */
  highlight: string
}

/** A title with its accent phrase in the primary colour and the rest forced white. */
export function AnnouncementTitle({ title, highlight }: AnnouncementTitleProps) {
  return (
    <HighlightedText
      highlight={highlight}
      highlightClassName="text-primary-main"
      text={title}
      textClassName="text-white"
    />
  )
}
